import { ElementType } from 'react'
import { CircleIcon, RoundedCheckIcon } from '@systemeio/ui-frontend'
import { XCircleFillIcon } from 'shared/icons/x-circle-fill-icon'
import { CourseLectureAssignmentStatusEnum } from '../types/course-menu-interface'

export const STATUS_ICONS = {
  [CourseLectureAssignmentStatusEnum.NotSubmitted]: CircleIcon,
  [CourseLectureAssignmentStatusEnum.Pending]: CircleIcon,
  [CourseLectureAssignmentStatusEnum.Approved]: RoundedCheckIcon,
  [CourseLectureAssignmentStatusEnum.Rejected]: XCircleFillIcon,
} as const satisfies Record<CourseLectureAssignmentStatusEnum, ElementType>
